import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./auth";
import usersReducer from "./user";
import ColorReducer from "./Color/ColorReducer";
import overviewReducer from "./overview";
import clientsReducer from "./clients";
import businessReducer from "./business";
import conversationsReducer from "./conversations";

import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { persistReducer } from "redux-persist";
import { encryptTransform } from "redux-persist-transform-encrypt";
import authAccessTransform from "./transforms/authAccess";

const VERSION = "root_v_1.0.0";
const encryptor = encryptTransform({
  secretKey: process.env.REACT_APP_SECRET_KEY,
  onError: function (error) {
    // Handle the error.
    console.error("encryptTransform", error);
  },
});

const persistConfig = {
  key: VERSION,
  storage,
  whitelist: ["auth", "color"],
  // blacklist: ["auth"],
  // stateReconciler: hardSet,
  transforms: [authAccessTransform, encryptor],
};

const rootReducer = combineReducers({
  auth: authReducer,
  users: usersReducer,
  color: ColorReducer,
  overview: overviewReducer,
  clients: clientsReducer,
  business: businessReducer,
  conversations: conversationsReducer,
});
export default persistReducer(persistConfig, rootReducer);
